// src/components/PastilleControle.jsx — LA PASTILLE ŒIL DU CONTRÔLE (lot frise).
//
// TROIS états, pas un de plus (décisions Dimitri) :
//   · bon              → VERTE avec coche (le contrôle n'a rien trouvé) ;
//   · a_reprendre /
//     reprise_en_cours → TERRACOTTA avec « ! » (des points attendent) ;
//   · regle            → VERTE avec flèche circulaire (la reprise est FAITE —
//                        boucle fermée, même vert que « bon »).
// Pas de contrôle → PAS de pastille : l'appelant ne rend rien, et un statut
// inconnu rend null ici (jamais une pastille qui ment).
//
// ~18-20 px, posée en ABSOLU au coin du bloc/carte par l'appelant (prop
// `style`) — elle ne déplace JAMAIS le contenu existant. L'œil discret dit
// « un contrôle est passé ici » ; le glyphe dit son état. aria-label français.
//
// Cliquable seulement si `onOuvrir` est fourni (ouvre le détail lecture
// seule) ; le pointerDown est stoppé pour ne jamais démarrer un glisser de
// bloc sous la pastille.

import { Check, Eye, RotateCw } from 'lucide-react'

// Vert de « validé » (même paire que la frise) ; terracotta charte 2026.
const VERT_FOND = '#7fc4a3'
const VERT_LISERE = '#1a4f3a'
const TERRA_FOND = '#c1512d'
const TERRA_LISERE = '#8f2f1d'

export const ETATS_PASTILLE = Object.freeze({
  bon: {
    fond: VERT_FOND, lisere: VERT_LISERE, texte: VERT_LISERE,
    glyphe: 'coche', libelle: 'Contrôlé : rien à signaler',
  },
  a_reprendre: {
    fond: TERRA_FOND, lisere: TERRA_LISERE, texte: '#fff',
    glyphe: 'point', libelle: 'Contrôlé : des points à reprendre',
  },
  reprise_en_cours: {
    fond: TERRA_FOND, lisere: TERRA_LISERE, texte: '#fff',
    glyphe: 'point', libelle: 'Contrôlé : reprise en cours',
  },
  regle: {
    fond: VERT_FOND, lisere: VERT_LISERE, texte: VERT_LISERE,
    glyphe: 'boucle', libelle: 'Contrôlé : points repris',
  },
})

export default function PastilleControle({ statut, onOuvrir, style = {}, testId }) {
  const etat = ETATS_PASTILLE[statut]
  if (!etat) return null
  return (
    <button
      type="button"
      // R-1 (WCAG 2.5.8) : dessin 18 px inchangé, ZONE DE CONTACT 44 px.
      className="fbz-hitbox44"
      data-testid={testId || `pastille-controle-${statut}`}
      aria-label={etat.libelle}
      title={etat.libelle}
      onClick={onOuvrir ? (e) => { e.stopPropagation(); onOuvrir() } : undefined}
      // Jamais un glisser de bloc démarré sous la pastille.
      onPointerDown={(e) => e.stopPropagation()}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 2,
        height: 18, padding: '0 5px', borderRadius: 9,
        background: etat.fond, color: etat.texte,
        border: 'none', boxShadow: `inset 0 0 0 1.5px ${etat.lisere}`,
        boxSizing: 'border-box',
        fontSize: 10, fontWeight: 800, lineHeight: 1,
        cursor: onOuvrir ? 'pointer' : 'default',
        ...style,
      }}>
      <Eye size={10} strokeWidth={2.4} aria-hidden="true" />
      {etat.glyphe === 'coche' && <Check size={10} strokeWidth={3} aria-hidden="true" />}
      {etat.glyphe === 'point' && <span aria-hidden="true">!</span>}
      {etat.glyphe === 'boucle' && <RotateCw size={10} strokeWidth={2.6} aria-hidden="true" />}
    </button>
  )
}
